import { District, Location, Measurement, DistrictStats, TemperatureStats, MeteoSchweizData } from '../types';
import { CSVDataService } from './csvDataService';

export class DataService {
  static async initialize(): Promise<void> {
    console.log('Initializing DataService...');
    await CSVDataService.loadAllData();
    console.log('DataService initialized successfully');
  }

  static async getDistricts(): Promise<District[]> {
    console.log('Getting districts...');
    await this.initialize();
    const districts = CSVDataService.getDistricts();
    console.log('Retrieved districts:', districts);
    return districts;
  }

  static async getLocations(): Promise<Location[]> {
    await this.initialize();
    return CSVDataService.getLocations();
  }

  static async getMeasurements(): Promise<Measurement[]> {
    await this.initialize();
    return CSVDataService.getMeasurements();
  }

  static async getMeteoSchweizData(): Promise<MeteoSchweizData[]> {
    await this.initialize();
    return CSVDataService.getMeteoSchweizData();
  }

  static async getMeasurementsWithUserComfort(): Promise<(Measurement & { user_comfort_answer?: string })[]> {
    await this.initialize();
    return CSVDataService.getMeasurementsWithUserComfort();
  }

  static async getDistrictStats(districtId?: number): Promise<DistrictStats[]> {
    await this.initialize();
    return CSVDataService.getDistrictStats(districtId);
  }

  static async getTemperatureStats(districtId: number, locationId?: number): Promise<TemperatureStats> {
    await this.initialize();
    return CSVDataService.getTemperatureStats(districtId, locationId);
  }
}
